import * as React from 'react';
import { ReportRecipientParticipant } from './models';
import SearchableDataModelList from '../layout/SearchableDataModelList';
import { Map } from '../language/models';


type Props = {
  className?: string;
  participants: ReportRecipientParticipant[];
  checkedParticipants: Map<ReportRecipientParticipant>;
  isChecked: (displayName: string) => boolean;
  toggleCheck: (displayName: string) => void;
}


/**
 * ReportRecipientParticipantList: a component that renders a searchable list of report recipient participants.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ReportRecipientParticipantList: React.FC<Props> = props => {
  const participantViewData = React.useMemo(
    () => props.participants.map(
      participant => ({ 
        key: participant.displayName,
        displayValue: participant.displayName + ' (' + participant.email + ')',
      }),
    ),
    [props.participants],
  );

  return (
    <SearchableDataModelList
      dataValues={participantViewData}
      isChecked={props.isChecked}
      toggleChecked={props.toggleCheck}
      isProject={false}
    />
  );
};

export default ReportRecipientParticipantList;
